<template>
  <v-dialog :value="actionPopup" max-width="800" :click:outside="closePopup">
    <v-card>
      <v-card-actions class="pb-0">
        <v-spacer></v-spacer>

        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>

      <v-card-text class="px-md-8">
        <h4 class="font font--h2-2 mb-2">Привет партнер! 👋</h4>

        <v-card-text class="font font--p-sm pa-1">
          На связи команда партнерской программы и мы хотим поговорить с тобой о важном :) Удели, пожалуйста 2 минуты и
          прочитай до конца, это правда важно, чтобы мы друг друга понимали.
        </v-card-text>
        <v-card-text class="font font--p-sm pa-1">
          👉 Мы очень ценим тебя как партнера и нам очень приятно что ты работаешь с нашим банком, для этого мы
          стараемся делать много крутых фич, аналогов которых до сих пор нет на рынке, как для тебя, так и для твоих
          клиентов.
        </v-card-text>

        <v-card-text class="font font--p-sm pa-1">
          Цель нашей партнерской программы - взаимовыгодное сотрудничество, в котором партнер зарабатывает совместно с
          банком, а клиент получает качественный сервис для своего бизнеса по конкурентной цене.
        </v-card-text>
        <v-card-text class="font font--p-sm pa-1">
          🖐 Мы ценим твое и свое время, поэтому не готовы работать с недобросовестными “партнерами”, кто пытается
          использовать партнерскую программу только для краткосрочного личного обогащения: открывают по 10 счетов одному
          клиенту, имитируют активность клиентов по счету, заведомо приводят в банк фирмы однодневки, паразитируют на
          брендовом трафике и тп
        </v-card-text>
        <v-card-text class="font font--p-sm pa-1">
          Давай договоримся и предупредим тебя заранее, что мы ожидаем от надежных партнеров:
          <ol class="ml-4">
            <li>
              Активных, “живых” клиентов с бизнесом - мы заинтересованы в том, чтобы клиент пользовался счетом и
              пробовал наши продукты
            </li>
            <li>
              Честного партнерства - без попыток обмануть нас, попытаться имитировать деятельность клиентов или убеждать
              клиентов открывать в Модуле “запасные” счета ради своей выгоды
            </li>
            <li>
              Заинтересованных клиентов для работы в нашем банке - не нужно пытаться отправить клиента, которому вы не
              продали Модульбанк
            </li>
            <li>
              Реальный бизнес - а не компании для мошеннических схем с номинальными директорами (если у тебя есть
              компании для нехороших дел - это не к нам, вы только потеряете время и деньги т.к у нас один из самых
              лучших комплаенсов на рынке)
            </li>
            <li>Позитивного настроения и обратной связи :)</li>
          </ol>
        </v-card-text>
        <v-card-text class="font font--p-sm pa-1"
          >В ответ, мы даем нашим надежным партнерам:
          <ol class="ml-4">
            <li>Крутые и современные продукты для бизнеса ваших клиентов</li>
            <li>Мотивацию партнеров с повышенными выплатами за активных клиентов с реальным бизнесом</li>
            <li>Моментальные выплаты партнерского вознаграждения сразу после завершения сделки</li>
            <li>Делимся прибылью по-честному от клиентов, не ограничивая заработок партнера (тариф пассивный доход)</li>
            <li>
              Возможность выстроить свою субартнерскую сеть на базе нашей партнерской программы и личного кабинета и
              иметь пассивный заработок
            </li>
            <li>Постоянную поддержку, которая готова помочь в любой ситуации</li>
            <li>Регулярные акции, в которых разыгрываем<strong> вкусные</strong> призы</li>
            <li>Открытость, и готовность развиваться совместно</li>
          </ol>
        </v-card-text>
        <v-card-text class="font font--p-sm pa-1"
          >💥Мы очень хотим с тобой долгосрочно и плодотворно работать и развиваться совместно, поэтому просим не
          нарушать наши простые правила. Мы быстро умеем понять недобросовестные намерения “партнеров” и, без обид,
          оставляем за собой право, при нарушении договора, не выплачивать вознаграждение, блокировать вывод средств или
          попрощаться навсегда - чего мы конечно же не любим :(
        </v-card-text>

        <v-card-text class="font font--p-sm pa-1">
          🥳 Приводи к нам хороших, активных и крутых клиентов - как ты сам и мы будем очень рады с тобой работать!
          Хорошего дня :)
        </v-card-text>

        <!-- <v-card-text class="font font--p-sm pa-1 font">Следите за новостями и всем удачи! </v-card-text> -->

        <!-- <v-card-text class="font font--p-sm  pa-1">
          Создавайте новые заявки, чтобы стать участником розыгрыша автоматически. Остались вопросы? Задавайте в{{
            "\xa0"
          }}<a href="https://t.me/modul_partner_bot" target="_blank" class="font font--p-sm">@Modul_Partner_Bot </a>или
          в{{ "\xa0" }}WhatsApp
          <a href="https://wa.me/79833202103" target="_blank" class="font font--p-sm">+79833202103</a>
        </v-card-text> -->

        <v-checkbox v-model="dontshow" color="#88BD1F" hide-details class="mb-1">
          <template v-slot:label>
            <div class="font font--p-sm">Больше не показывать</div>
          </template>
        </v-checkbox>
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn @click="closePopup" color="primary" min-width="210" large>Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  methods: {
    ...mapMutations("profile", ["closePopup"]),
  },
  computed: {
    ...mapGetters({
      actionPopup: "profile/showPopup",
    }),
    dontshow: {
      get() {
        return window.localStorage.getItem("dont_show_dec_new_popup") || false;
      },
      set(value) {
        window.localStorage.setItem("dont_show_dec_new_popup", value);
      },
    },
  },
};
</script>
